import { prettyError, prettyErrorButton, prettyErrorDescription, prettyErrorSubButton } from 'constants/errors'
import ButtonCloseMenu from 'components/button-close'
import GenericError from 'components/generic-error'
import { useContext, useEffect, useState } from 'react'
import { useBg } from 'hooks/use-white-bg'
import useRouter from 'hooks/use-router'
import { SectionError } from 'theme/error'
import { LiError, TextError, TitleError, IconError } from 'components/generic-error/components/style/text'
import { Link } from 'react-router-dom'
import useMainClass from 'hooks/use-main-cass'
import { LoaderContext } from 'contexts/loader-context'
import textServices from 'services/text-services'
import CONFIGS from 'build/Config'

type IFunctionRetry = (code: number | string | null) => void

export const ContainerError = ({ children, handleMenu }: { children: JSX.Element, handleMenu: () => void }) => {
  const [shouldUseWhiteBg] = useState(useBg)
  useMainClass('error')

  const { setFooter } = useContext(LoaderContext)

  useEffect(() => {
    setFooter(false)
    return () => setFooter(true)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg: !CONFIGS?.error?.dontUseSecondBg
        }
      })
      window.dispatchEvent(event)
    }, 200)

    return () => {
      const event = new CustomEvent('background-color', {
        detail: {
          shouldUseWhiteBg
        }
      })

      window.dispatchEvent(event)
    }
  }, [])


  return (
    <div className="flex justify-center items-center w-full flex-col text-center px-7 flex-1">
      <ButtonCloseMenu
        open={true}
        paramFn={handleMenu}
      />
      <div className="space-y-4 flex-1 flex flex-col items-center justify-center py-7 w-full">
        {children}
      </div>
    </div>
  )
}

function ErrorView({ code, onRetry, buttonMenu, onSubRetry }: { code: number | string | null, onRetry?: IFunctionRetry, onSubRetry?: IFunctionRetry, buttonMenu?: IFunctionRetry }) {
  const { title, description, button, subButton } = { title: prettyError(code), description: prettyErrorDescription(code), button: prettyErrorButton(code), subButton: prettyErrorSubButton(code) }
  const { history } = useRouter()
  const { setFooter } = useContext(LoaderContext)

  const handleMenu = () => {
    if (buttonMenu) buttonMenu(code)
  }

  const handleButton = () => {
    if (onRetry) onRetry(code)
  }

  const handleRetry = () => {
    if (title === 'Ha ocurrido un error') return history.push('/help')
    return handleButton()
  }

  const handleSubRetry = () => {
    if (onSubRetry) onSubRetry(code)
  }

  useEffect(() => {
    setFooter(false)
    return () => setFooter(true)
  }, [])

  return (
    <ContainerError handleMenu={handleMenu}>
      <GenericError code={code} error={title} description={description} buttonText={button} onRetry={handleRetry} subButtonText={subButton} onSubRetry={handleSubRetry} />
    </ContainerError >
  )
}

export function ErrorListView({ code, list, buttonMenu, multimediaId }: { list: string[], code: number | string | null, multimediaId?: number | string, onRetry?: IFunctionRetry, buttonMenu?: IFunctionRetry }) {
  const { title, description } = { title: prettyError(code), description: prettyErrorDescription(code) }

  const handleMenu = () => {
    if (buttonMenu) buttonMenu(code)
  }

  return (
    <ContainerError handleMenu={handleMenu}>
      <SectionError className="flex-1 flex flex-col justify-center items-center max-w-full space-y-4 mx-8 my-8 w-full">
        <div className="flex-1  flex flex-col itemx-center justify-center gap-4">
          <IconError className='flex justify-center items-center'>
            <svg width="124" height="124" viewBox="0 0 124 124" fill="none" className='icon-error' xmlns="http://www.w3.org/2000/svg">
              <circle cx="62" cy="62" r="60" stroke="currentColor" strokeWidth="4" />
              <path d="M35 87.5L89 36" stroke="currentColor" strokeWidth="6" strokeLinecap="square" />
              <path d="M36.25 34.75L87.75 88.75" stroke="currentColor" strokeWidth="6" strokeLinecap="square" />
            </svg>
          </IconError>
          <TitleError className="text-center text-3xl uppercase font-bold error__title">{title}</TitleError>
          <TextError className="text-center mx-2 error__description">{description}</TextError>
          <div className='px-4 flex justify-center items-center'>
            <ul style={{ listStyle: 'initial' }}>
              {
                list?.map((item: string, index) => (
                  <LiError className='font-semibold text-base error__li' key={index}>{item}</LiError>
                ))
              }
            </ul>
          </div>
        </div>
        <div className='flex flex-col items-center justify-center'>
          <TextError className='error__description'><b>{textServices.findByText('error/notLikeThat/title', { es: '¿Te parece que no es asi?', en: 'Do you think it is not so?' })}</b></TextError>
          <TextError className='error__description'>{textServices.findByText('error/notLikeThat/description', { es: <>Ponte en contacto con nosotros para que podamos ayudarte. <Link to={`/help${multimediaId ? `?rallyMultimediaId=${multimediaId}` : ''}`} className='underline'>Mándanos un mensaje</Link></>, en: <>Please contact us so we can help you. <Link to='/help' className='underline'>Message us</Link></> })}</TextError>
        </div>
      </SectionError>
    </ContainerError >
  );
};

export function ErrorModeration({ code, buttonMenu }: { code: number | string | null, onRetry?: IFunctionRetry, buttonMenu?: IFunctionRetry }) {
  const { title, description } = { title: prettyError(code), description: prettyErrorDescription(code) }

  const handleMenu = () => {
    if (buttonMenu) buttonMenu(code)
  }

  return (
    <ContainerError handleMenu={handleMenu}>
      <SectionError className="flex-1 flex flex-col justify-center items-center max-w-full space-y-4 mx-8 my-8 w-full">
        <div className="flex-1  flex flex-col itemx-center justify-center gap-4">
          <IconError className='flex justify-center items-center'>
            <svg width="125" height="124" viewBox="0 0 125 124" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="62.5" cy="62" r="60" stroke="currentColor" strokeWidth="4" />
              <path d="M62 30C63.9375 30 65.6562 30.5625 67.1562 31.6875C68.7188 32.8125 69.8125 34.25 70.4375 36H92V42H87.7812L100.625 64.5L101 65.25V66C101 68.6875 100.312 71.1875 98.9375 73.5C97.625 75.8125 95.8125 77.6562 93.5 79.0312C91.1875 80.3438 88.6875 81 86 81C83.3125 81 80.8125 80.3438 78.5 79.0312C76.1875 77.6562 74.3438 75.8125 72.9688 73.5C71.6562 71.1875 71 68.6875 71 66V65.25L71.375 64.5L84.2188 42H70.4375C70 43.25 69.2812 44.375 68.2812 45.375C67.3438 46.3125 66.25 47 65 47.4375V87H77V93H47V87H59V47.4375C57.75 47 56.625 46.3125 55.625 45.375C54.6875 44.375 54 43.25 53.5625 42H39.7812L52.625 64.5L53 65.25V66C53 68.6875 52.3125 71.1875 50.9375 73.5C49.625 75.8125 47.8125 77.6562 45.5 79.0312C43.1875 80.3438 40.6875 81 38 81C35.3125 81 32.8125 80.3438 30.5 79.0312C28.1875 77.6562 26.3438 75.8125 24.9688 73.5C23.6562 71.1875 23 68.6875 23 66V65.25L23.375 64.5L36.2188 42H32V36H53.5625C54.1875 34.25 55.25 32.8125 56.75 31.6875C58.3125 30.5625 60.0625 30 62 30ZM62 36C61.1875 36 60.4688 36.2812 59.8438 36.8438C59.2812 37.4062 59 38.125 59 39C59 39.8125 59.2812 40.5312 59.8438 41.1562C60.4688 41.7188 61.1875 42 62 42C62.875 42 63.5938 41.7188 64.1562 41.1562C64.7188 40.5312 65 39.8125 65 39C65 38.125 64.7188 37.4062 64.1562 36.8438C63.5938 36.2812 62.875 36 62 36ZM38 51.0938L31.1562 63H44.8438L38 51.0938ZM86 51.0938L79.1562 63H92.8438L86 51.0938ZM29.75 69C30.375 70.75 31.4062 72.1875 32.8438 73.3125C34.3438 74.4375 36.0625 75 38 75C39.9375 75 41.625 74.4375 43.0625 73.3125C44.5625 72.1875 45.625 70.75 46.25 69H29.75ZM77.75 69C78.375 70.75 79.4062 72.1875 80.8438 73.3125C82.3438 74.4375 84.0625 75 86 75C87.9375 75 89.625 74.4375 91.0625 73.3125C92.5625 72.1875 93.625 70.75 94.25 69H77.75Z" fill="currentColor" />
            </svg>
          </IconError>
          <TitleError className="text-center text-3xl uppercase font-bold error__title">{title}</TitleError>
          <TextError className="text-center mx-2 error__description">{description}</TextError>
        </div>
      </SectionError>
    </ContainerError >
  );
};

export default ErrorView;